import { PropsWithChildren, useRef } from 'react'

import { RemoteTableStoreRef } from '@eastcoal/common/components/RemoteTable/Store/interface'

import { BidMemberListModalStoreContext } from './contexts/StoreContext'

export const BidMemberListModalStoreProvider = ({
  children
}: PropsWithChildren) => {
  const tableRef = useRef<RemoteTableStoreRef>(null)

  return (
    <BidMemberListModalStoreContext value={{ tableRef }}>
      {children}
    </BidMemberListModalStoreContext>
  )
}
